import React from 'react'
import { Link } from 'react-router-dom';
import { Grid, IconButton, Drawer, Button, List, ListItem, ListItemText, TextField, Tabs, Tab } from '@mui/material';
import {
  Card, CardActionArea, CardMedia, CardContent, Typography, Box, InputAdornment 
} from '@mui/material';
import {useTheme, useMediaQuery } from '@mui/material';
import chef from "../assests/images/chef5.jpg"
import { BiFontSize } from 'react-icons/bi';
export default function SideContent() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (

    <Grid container sx={{
        display: 'flex',
        flexDirection: 'column'
    }}
    
    > 

    <Box   bgcolor="#f9eae1"   sx={{
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
               
                alignItems: 'center',  // Center items horizontally
             padding: '0 2rem',
                marginY: {
                    xs: '1rem', // Space between rows for mobile
                    sm: '2rem',    // No extra space for larger screens
                  },
                 
            }}>

    <Box
                sx={{
                width: !isSmUp ? '150px': '250px',  // Set width and height for the image container
                height: !isSmUp ? '150px' : '250px',
                overflow: 'hidden',  // Ensures the image stays within the circle
                borderRadius: '50%',  // Makes the container circular
                marginTop: '-4rem',   // Adjust margin if needed to make the image overlap
                border: '4px solid white'  // Optional: adds a white border around the image
                }}
            >
                <img
                    alt="Chef Adel"
                    src={chef} // Use the determined image source
                    style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    }}
                />
            </Box>

            <Box 
       
        sx={{
                 display: 'flex',
                 flexDirection: 'column',
                 justifyContent: 'center',
                 alignItems: 'center',
                 textAlign: 'center',
                 my:'2rem'    
                
                }}
        >
        <Typography component="h6" variant="h6" align="center" mb={1} className='heading' >
        Hi! I'm Chef Adel
         </Typography>
         <Typography component="h3" variant="h3" align="center" mb={1} className={isSmUp ? 'sub-heading' : 'sub-heading-2'}sx={{color: '#968b8b'}} >
         Over a Decade of Mastering Diverse Cuisines
         </Typography>
         <Typography component="p" variant="p" align="center" mb={1} className='body' >
     My journey, which began in 2011, has taken me across Italy, France, the Middle East, and Turkey, where I’ve honed my craft under world-renowned chefs. Whether it's mastering diverse cuisines or reviving a restaurant from the brink of closure, I’m driven by my love for food, innovation, and excellence.         </Typography>
         <Link to="/about" class="button-48" style={{marginTop: '2rem'}} role="button"><span class="text">Learn More</span></Link>

        </Box>
    </Box>

    {/* <Box 
    sx={{
      display: 'flex',
      flexDirection: 'column'

    }}>
         <Box item xs={12} > 
          <Typography variant="h4" component="h3" align="center" gutterBottom>
            Featured Content
          </Typography>
        </Box>

        <Grid container spacing={2}
    sx={{
      display: 'flex',
      flexDirection: 'row'

    }}>

        <Grid item xs={12} md={6}  > 
          <Card>
            <CardMedia
              component="img"
              height="300"
              image="https://via.placeholder.com/600x300"
              alt="Featured Recipe"
            />
            <CardContent>
              <Typography variant="h6" component="h4" gutterBottom>
                Top Recipe: Perfect Pasta
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Learn how to make the perfect pasta with this easy-to-follow recipe. From boiling the pasta to making the perfect sauce, we've got you covered.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardMedia
              component="img"
              height="300"
              image="https://via.placeholder.com/600x300"
              alt="Chef Recommendation"
            />
            <CardContent>
              <Typography variant="h6" component="h4" gutterBottom>
                Chef’s Recommendation
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Our top chef recommends this dish for a fine dining experience at home. Fresh ingredients, masterful techniques, and exceptional flavor await you.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        </Grid >

    </Box> */}
    </Grid>
  )
}
